export var CheckoutErrorType;
(function (CheckoutErrorType) {
    /**
     * 获取收获地址错误
     */
    CheckoutErrorType["ADDRESS_INVALID"] = "ADDRESS_INVALID";
    /**
     * 配送限制
     */
    CheckoutErrorType["SHIPPING_RESTRICTION"] = "SHIPPING_RESTRICTION";
    /**
     * 送货方式错误
     */
    CheckoutErrorType["DELIVERY_ERROR"] = "DELIVERY_ERROR";
    /**
     * 获取能使用的优惠券列表错误
     */
    CheckoutErrorType["GET_CAN_USER_COUPON_LIST_ERROR"] = "GET_CAN_USER_COUPON_LIST_ERROR";
    /**
     * 获取结算信息错误
     */
    CheckoutErrorType["GET_CHECKOUT_INFO_ERROR"] = "GET_CHECKOUT_INFO_ERROR";
    /**
     * 获取优惠券列表错误
     */
    CheckoutErrorType["GET_COUPON_LIST_ERROR"] = "GET_COUPON_LIST_ERROR";
    /**
     * 输入优惠券code错误
     */
    CheckoutErrorType["INPUT_COUPON_CODE_ERROR"] = "INPUT_COUPON_CODE_ERROR";
    /**
     * 创建订单报错
     */
    CheckoutErrorType["SUBMIT_ORDER_ERROR"] = "SUBMIT_ORDER_ERROR";
    /**
     * 删除收货地址错误
     */
    CheckoutErrorType["DELETE_CONSIGNEE_ADDRESS_ERROR"] = "DELETE_CONSIGNEE_ADDRESS_ERROR";
    /**
     * 获取分类列表以及推荐品牌接口报错
     */
    CheckoutErrorType["GET_HOME_CATEGORY_DATA_ERROR"] = "GET_HOME_CATEGORY_DATA_ERROR";
    /**
     * 获取积分详情报错
     */
    CheckoutErrorType["GET_POINT_DETAIL_ERROR"] = "GET_POINT_DETAIL_ERROR";
})(CheckoutErrorType || (CheckoutErrorType = {}));
export var CartErrorType;
(function (CartErrorType) {
    /**
     * 选择换购商品错误
     */
    CartErrorType["EXCHANGE_SELECT_PRODUCT_ERROR"] = "EXCHANGE_SELECT_PRODUCT_ERROR";
    /**
     * 选择商品错误
     */
    CartErrorType["SELECT_PRODUCT_ERROR"] = "SELECT_PRODUCT_ERROR";
    /**
     * 多品加车报错
     */
    CartErrorType["MULTIGOODS_ADD_CART_ERROR"] = "MULTIGOODS_ADD_CART_ERROR";
    /**
     * 选择多品促销报错
     */
    CartErrorType["SELECT_PROMOTION_ERROR"] = "SELECT_PROMOTION_ERROR";
    /**
     * 购物车商品全部选择报错
     */
    CartErrorType["CART_SELECT_ALL_ERROR"] = "CART_SELECT_ALL_ERROR";
    /**
     * 前往结算报错
     */
    CartErrorType["GOTO_CHECKOUT_ERROR"] = "GOTO_CHECKOUT_ERROR";
    /**
     * 批量删除购物车商品报错
     */
    CartErrorType["BATCH_DELETE_CART_ERROR"] = "BATCH_DELETE_CART_ERROR";
    /**
     * 获取购物车数量报错
     */
    CartErrorType["GET_CART_COUNT_ERROR"] = "GET_CART_COUNT_ERROR";
    /**
     * 获取购物车详情报错
     */
    CartErrorType["GET_CART_DETAIL_ERROR"] = "GET_CART_DETAIL_ERROR";
    /**
     * 删除购物车商品报错
     */
    CartErrorType["REMOVE_PRODUCT_ERROR"] = "REMOVE_PRODUCT_ERROR";
    /**
     * 修改购物车商品数量报错
     */
    CartErrorType["CHANGE_PRODUCT_COUNT_ERROR"] = "CHANGE_PRODUCT_COUNT_ERROR";
})(CartErrorType || (CartErrorType = {}));
export var PaymentErrorType;
(function (PaymentErrorType) {
    /**
     * 获取支付方式错误
     */
    PaymentErrorType["GET_PAY_MODE_ERROR"] = "GET_PAY_MODE_ERROR";
    /**
     * 获取支付信息错误
     */
    PaymentErrorType["PAYMODE_METHOD_NOT_FOUND"] = "PAYMODE_METHOD_NOT_FOUND";
})(PaymentErrorType || (PaymentErrorType = {}));
export var GolbalError;
(function (GolbalError) {
    /**
     * 全局js报错
     */
    GolbalError["GLOBAL_JS_ERROR"] = "GLOBAL_JS_ERROR";
    /**
     * 全局接口报错
     */
    GolbalError["GLOBAL_API_ERROR"] = "GLOBAL_API_ERROR";
})(GolbalError || (GolbalError = {}));
